export default {
  CREATE_CREDENTIALS_REQUEST: 'CREATE_CREDENTIALS_REQUEST',
  CREATE_CREDENTIALS_SUCCESS: 'CREATE_CREDENTIALS_SUCCESS',
  CREATE_CREDENTIALS_FAILURE: 'CREATE_CREDENTIALS_FAILURE',
};
